<dx-data-grid
  #grid
  height="100%"
  [dataSource]="lignes()"
  [keyExpr]="keyExpr"
  noDataText="Pas de données"
  showBorders="true"
  showRowLines="true"
  allowColumnResizing="true"
  rowAlternationEnabled="true"
  columnResizingMode="widget"
  (onToolbarPreparing)="onToolbarPreparing($event)"
  (onCellClick)="onCellClick($event)">

  <dxo-selection
    selectAllMode="allPages"
    showCheckBoxesMode="always"
    mode="multiple">
  </dxo-selection>

  <dxo-column-chooser mode="select" [enabled]="true"></dxo-column-chooser>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxo-header-filter [visible]="true"></dxo-header-filter>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} ligne(s) de paramétrage">
  </dxo-pager>

  <dxi-column
    caption="Point de livraison"
    dataField="plcLibelle">
  </dxi-column>
  <dxi-column
    caption="Produit complémentaire"
    dataField="produitLibelle">
  </dxi-column>
  <dxi-column
    caption="Taxe"
    dataField="taxeLibelle"
    cssClass="pointer"
    cellTemplate="taxeTemplate">
  </dxi-column>
  <dxi-column
    caption="Prix de vente HT"
    alignment="center"
    cellTemplate="prixTemplate"
    [allowSorting]="false"
    [allowFiltering]="false">
  </dxi-column>

  <div *dxTemplate="let cell of 'taxeTemplate'" title="Modifier la taxe">
    <span *ngIf="cell?.value; else taxeVide">{{ cell.value }}</span>
    <ng-template #taxeVide><span class="taxe-vide">Sélectionner une taxe...</span></ng-template>
  </div>

  <div *dxTemplate="let cell of 'prixTemplate'" class="prix-container">
    <ng-container *ngFor="let periode of cell?.row?.data?.periodeParametrageFacturationList">
      <div>
        <span>{{ utilsSvc.isIdInit(periode?.id) ? '' : '+' }}</span>
        <span>{{ periode?.periodeToDelete ? '-' : ''}}</span>
        <span
          *ngIf="periode?.conditionnementObsolete"
          class="periode-obsolete"
          title="Période obsolète : conditionnement supprimé ou produit non facturable">
        </span>
        <label class="badge badge-secondary pointer"
               title="Modifier cette période de prix"
               (click)="onPeriodeBadgeClick(cell.row.data, periode)">
          {{ utilsSvc.formatDate(periode?.dateDebut) }}
        </label>
        <span *ngIf="periode?.uniteDeMesure" class="periode-condi">({{ periode.uniteDeMesure }})</span>
        <span *ngIf="periode?.prixVenteHT != null; else prixASaisir" class="periode-prix-montant"> {{ periode.prixVenteHT.toFixed(3) }} €</span>
        <ng-template #prixASaisir><span class="periode-prix-montant prix-a-saisir"> A saisir</span></ng-template>
      </div>
    </ng-container>
  </div>

  <div *dxTemplate="let cell of 'beforeTemplate'">
    <ng-content select="[data-position='left']"></ng-content>
  </div>

  <div *dxTemplate="let cell of 'afterTemplate'">
    <ng-content select="[data-position='right']"></ng-content>
  </div>

  <ng-content></ng-content>

</dx-data-grid>
